module.exports = __webpack_public_path__ + "components/Map/graphics/tree-pin.320f1b780d90267a1d5eafe8ded06cfa.png";